.ds-toggler-item {
  display: block;

  &__title {
    cursor: pointer;
  }

  &__content {
    overflow: hidden;
    height: 0;

    & > div {
      position: relative;
    }

    &.--js-animated {
      transition: height ease 0.4s;
    }
  }
}
